import { render, staticRenderFns } from "./BuyMemberModal.vue?vue&type=template&id=8183d8d2&scoped=true"
import script from "./BuyMemberModal.vue?vue&type=script&lang=js"
export * from "./BuyMemberModal.vue?vue&type=script&lang=js"
import style0 from "./BuyMemberModal.vue?vue&type=style&index=0&id=8183d8d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8183d8d2",
  null
  
)

export default component.exports